import { render, staticRenderFns } from "./FileGallery.vue?vue&type=template&id=eb38169c&"
import script from "./FileGallery.vue?vue&type=script&lang=js&"
export * from "./FileGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports